import Vue from 'vue';
import { _api } from '@/utils/apiAxios';
import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';
import { changeLineStyle } from '@/utils/api';
import router from '@/router';
import { getDeviceMacAddress } from '@/plugins/macAddressResolver';
import { LoginTypes, ExternalWagerLoginTypes } from '@/utils/enums';
import { log } from '@/utils/logging';
import Cookies from 'js-cookie';
import { getRootDomain } from '@/utils/common';
import { changeLanguage, changeTimezone } from '../../utils/api';
import i18n from '../../utils/i18n';
import snq from 'snq';
import { LS_CLIENT_TYPE } from '@/utils/consts';
import * as Sentry from '@sentry/browser';
import store from '@/store';
import { isElectronContext } from '../../utils/isElectron';

const isElectron = isElectronContext() || typeof Epos_Android_Interface != 'undefined';

let counterInterval = null;
//TODO brandsettings implementation should be done!!!!!
const state = {
  oddTypes: [
    {
      dgsCode: 'E',
    },
    {
      dgsCode: 'F',
    },
    {
      dgsCode: 'D',
    },
  ],
  loading: true,
  selectedOddType: 'E',
  selectedOddLoading: false,
  selectedLocale: {},
  openAccountMenu: false,
  socketConnection: 0,
  casinoSocketConnection: 0,
  menuSocketConnection: 0,
  socketInterval: 1000 * 15,
  macAddress: null, // This variable calculated in "macAddressResolver" file before App loads.
  lineAvailabilityInterval: 1000 * 60,
  terminalInfo: null,
  clientType: null,
  openCallBackModal: false,
  banners: [],
  casinobanners: [],
  brandSettings: {
    brand_logo: '',
    brand_color: '#070a14',
    brand_textcolor: '#070a14',
    socketInterval: 1000 * 15,
    location_settings: {
      available_languages: '[]',
    },
  },
  loyaltyCardResponse: null,
  showScanBarcodeModal: false,
  terminalInfoError: null,
  timeZone: {},
  timeZones: [],
  appLoading: true,
  timeSpent: 0,
  newTerminalRequest: false,
  clerkBalance: '0.00',
  rePrintModal: { show: false, counter: 40 },
  userIpInfo: {},
  languageLoading: false,
  isBalanceLoading: false,
  isScanningCodeForMobile: false,
  mobileQRParameters: {
    scanCode: null,
    time: null,
    publicKey: null,
    companyId: null,
  },
};
const getters = {
  getField,
  canClerkLogin: state => state.terminalInfo.can_clerk_login === '1',
  shouldDisableCasino: (state, getters, rootState) => {
    if (state.clientType === 'WEB' && state.brandSettings.is_casino_available_for_web === false) {
      return true;
    }
    if (state.clientType === 'ELECTRON' && state.brandSettings.is_casino_available_for_kiosk === false) {
      return true;
    }
    if (rootState.player.loginType === LoginTypes.Player && rootState.player.player.PlayerInfo) {
      return rootState.player.player.PlayerInfo.DGS.casino_enabled === '0';
    } else {
      return false;
    }
  },
  shouldDisableSportsbook: (state, getters, rootState) => {
    if (rootState.player.loginType === LoginTypes.Player && rootState.player.player.PlayerInfo) {
      return rootState.player.player.PlayerInfo.DGS.sports_enabled === '0';
    }
    return false;
  },
  shouldDisableHorse: (state, getters, rootState) => {
    const isNotAvailableForWeb = !snq(() => rootState.settings.terminalInfo.brand_settings.is_horse_available_for_web);
    const isNotAvailableForKiosk = !snq(
      () => rootState.settings.terminalInfo.brand_settings.is_horse_available_for_kiosk,
    );

    if (isElectron) {
      if (isNotAvailableForKiosk) {
        return true;
      }
    } else {
      if (isNotAvailableForWeb) {
        return true;
      }
    }

    if (rootState.player.loginType === LoginTypes.Player && rootState.player.player.PlayerInfo) {
      return rootState.player.player.PlayerInfo.DGS.horses_enabled === '0';
    }

    return false;
  },
  getTimeZoneById: state => id => {
    return state.timeZones.find(_ => _.id.toString() === id.toString());
  },
  canClerkSeeBalance: state => {
    return snq(() => state.terminalInfo.location.clerk_can_see_balance == 1);
  },
  currencySymbol: state => {
    return state.terminalInfo.currency_symbol;
  },
  mustBrandHide: state => !(snq(() => state.terminalInfo.location.hide_brand) && isElectron),
  liveBetDelay: state =>
    isElectronContext()
      ? snq(() => parseInt(state.terminalInfo.location.brand.settings.live_bet_delay_time_in_ms) / 1000)
      : snq(() => parseInt(state.terminalInfo.brand_settings.brand_defaults.live_bet_delay_time_in_ms) / 1000), // from milli to sec
  allowPartialBetPayout: state => snq(() => state.terminalInfo.location.allow_partial_bet_payout),
  getLocationMinBet: state => parseFloat(snq(() => state.terminalInfo.location.min_bet) || 0),
};
const mutations = {
  updateField,
  setAppLoading: (state, data) => {
    state.appLoading = data;
  },
  requestStart: state => {
    state.loading = true;
  },
  terminalInfoError: (state, data) => {
    state.terminalInfoError = data;
  },
  requestEnded: state => {
    state.loading = false;
  },
  setSelectedOddType: (state, dgsCode) => {
    state.selectedOddType = dgsCode;
  },
  setOddTypes: (state, data) => {
    state.oddTypes = data;
  },
  setSelectedOddLoading: (state, value) => {
    state.selectedOddLoading = value;
  },
  setSelectedLocale: (state, locale) => {
    let newLocale = JSON.parse(state.brandSettings.location_settings.available_languages).find(
      item => item.code === locale || item.short_code === locale,
    );
    if (newLocale) {
      state.selectedLocale = newLocale;
      Cookies.set('locale', locale, {
        expires: 5,
        domain: getRootDomain(location.hostname),
      });
    }
  },
  openOrCloseAccountMenu: (state, val) => {
    state.openAccountMenu = val;
  },
  openOrCloseCallbackModal: (state, val) => {
    state.openCallBackModal = val;
  },
  setTerminalInfo: (state, data) => {
    state.terminalInfo = data;
    state.clientType = data.client_type;
    localStorage.setItem(LS_CLIENT_TYPE, data.client_type);
    localStorage.setItem('epos_token', data.brand_settings.location_settings.epos_token);
  },
  setBrandInfo: (state, data) => {
    if (data) {
      const link = document.querySelector("link[rel*='icon']");
      if (data.brand_theme.name === 'Apueston') {
        link.href = '/assets/images/apueston-favicon.png';
      }
      if (data.brand_theme.name === 'Instabet') {
        // let locale = instabetLocale;
        // state.selectedLocale = state.locales.filter(item => item.key === locale)[0];
        link.href = '/assets/images/instabet-favicon.png';
      } else {
        link.href = '/assets/images/epos-favicon.ico';
      }
      var themeJson = JSON.parse(data.brand_theme.Settings_Json);
      Object.keys(themeJson).forEach(i => {
        document.documentElement.style.setProperty('--' + i, themeJson[i]);
      });
      document.title = data.brand_name.toUpperCase();

      Vue.prototype.$cdn = data.engine_cdn_url + 'assets';
      state.brandSettings = data;
      state.brandSettings.brand_url = data.brand_name.replace(' ', '.');
    }
  },
  setBanners: (state, data) => {
    state.banners = data;
  },
  setCasinoBanners: (state, data) => {
    state.casinobanners = data;
  },
  setLoyaltyCarResponse: (state, data) => {
    state.loyaltyCardResponse = data;
  },
  setShowScanBarcodeModal: (state, data) => {
    state.showScanBarcodeModal = data;
  },
  setDefaultTimeZone: (state, data) => {
    let timeZone = state.timeZones.find(i => i.id == data);
    if (!timeZone) {
      timeZone = state.timeZones.find(i => i.is_default);
    }
    state.timeZone = timeZone;
    Cookies.set('tz', timeZone.id, {
      domain: getRootDomain(location.hostname),
    });
  },
  setTimeZones: (state, data) => {
    state.timeZones = data;
  },
  setTimeSpent: (state, data) => {
    state.timeSpent = data;
  },
  setNewTerminalRequest: (state, data) => {
    state.newTerminalRequest = data;
  },
  setClerkBalance: (state, data) => {
    state.clerkBalance = data;
  },
  setUserIpInfo: (state, data) => {
    state.userIpInfo = data;
  },
  setReprintModal: (state, data) => {
    const loginType = store.state.player.loginType;
    const isAnonym = loginType === ExternalWagerLoginTypes.DepositTicket;

    if (isAnonym) {
      if (data.counter === 40) {
        data.counter = 10;
      }
    }

    state.rePrintModal = {
      counter: isAnonym ? 10 : 40,
      scanCode: state.rePrintModal.scanCode,
      ...data,
      isAnonym: isAnonym,
    };
  },
  setLanguageLoading: (state, data) => {
    state.languageLoading = data;
  },
  setIsBalanceLoading: (state, data) => {
    state.isBalanceLoading = data;
  },
  setIsScanningCodeForBrowser: (state, data) => {
    state.isScanningCodeForMobile = data;
  },
  setMacAddress: (state, data) => {
    state.macAddress = data;
  },
  setMobileQRParameters: (state, data) => {
    state.mobileQRParameters = data;
  },
};
const actions = {
  setReprintModal: ({ commit, state }, data) => {
    commit('setReprintModal', {
      scanCode: data.scanCode,
      show: data.show,
      counter: 40,
    });
    if (data.show) {
      counterInterval = setInterval(() => {
        let count = state.rePrintModal.counter - 1;
        commit('setReprintModal', { show: data.show, counter: count });
        if (state.rePrintModal.counter === 0) {
          commit('setReprintModal', { show: false, counter: 40 });
          clearInterval(counterInterval);
        }
      }, 1000);
    } else {
      commit('setReprintModal', { show: false, counter: 40 });
      clearInterval(counterInterval);
    }
  },
  setTimeSpent: ({ commit }, data) => {
    commit('setTimeSpent', data);
  },
  setOddType: ({ commit, dispatch, rootGetters }, oddType) => {
    commit('setSelectedOddType', oddType);
    dispatch('openBetsStore/tryGetOpenBets', null, { root: true });
    if (rootGetters['player/isPlayerOrClerkLoggedIn']) {
      changeLineStyle(oddType);
    }
  },
  setAppLoading: ({ commit }, data) => {
    commit('setAppLoading', data);
  },
  setLocale: async ({ commit, dispatch, state, rootState, rootGetters }, locale) => {
    //For Change player state without relogin
    const available_languages = JSON.parse(
      rootState.settings.terminalInfo.brand_settings.location_settings.available_languages,
    );
    if (!!rootState.player.player.PlayerInfo && !!rootState.player.player.PlayerInfo.DGS.language) {
      const userLocale = available_languages.find(f => f.short_code == locale);
      rootState.player.player.PlayerInfo.DGS.language = userLocale.id;

      commit('player/setPlayer', rootState.player.player, { root: true });
    }
    // End

    let beforeLanguage = Cookies.get('locale');
    if (rootGetters['player/isPlayerOrClerkLoggedIn']) {
      if (beforeLanguage !== locale) {
        let obj = {
          language: locale,
        };
        await changeLanguage(obj);
      }
      if (typeof rootState.player.player.language !== 'undefined') {
        locale = rootState.player.player.language;
      }
    }
    //moment.locale(locale.short_code);
    commit('setSelectedLocale', locale);
    await dispatch('cmsSettings/SET_CMS_SETTNGS', state.brandSettings.cms_site_url, { root: true });
  },
  tryChangeLineStyle: ({ commit }, dgsCode) => {
    changeLineStyle(dgsCode);
  },
  getClerkBalance: async ({ commit, state, rootState }) => {
    if (
      snq(() => state.terminalInfo.location.clerk_can_see_balance == 1) &&
      isElectron &&
      LoginTypes.Clerk == rootState.player.loginType
    ) {
      let res = await _api.get('/terminal/balance?terminalId=' + state.terminalInfo.terminal_id);
      if (res.data.IsSuccess) {
        let balance = parseFloat(res.data.Data.data || 0).toFixed(2);
        commit('setClerkBalance', balance);
      }
    }
  },
  async getTerminalInfo({ commit, state, dispatch, rootState }, query) {
    const instance = axios.create();
    instance.defaults.headers.common = {};
    // const userIpInfoRes = await instance.get('https://get.geojs.io/v1/ip/geo.json');
    const userIpInfo = {};
    commit('setUserIpInfo', userIpInfo);

    commit('requestStart');
    const scanCode = query ? query.qr : undefined;
    const time = query ? query.t : undefined;
    const publicKey = query ? query.pk : undefined;
    const companyId = query ? query.c : undefined;

    let res;

    if (scanCode && time && publicKey && companyId) {
      commit('setIsBalanceLoading', true);
      res = await _api.get(`/qrwalet/loadscan?sc=${scanCode}&t=${time}&c=${companyId}&pk=${publicKey}`);
      if (
        !res.data.IsSuccess &&
        res.data.ExceptionMessage &&
        res.data.ExceptionMessage[0] === 'PUBLIC_KEY_VALIDATION_FAIL'
      ) {
        Vue.toasted.show('Codigo Invalido o ha expirado', {
          type: 'error',
          position: 'bottom-center',
          duration: 10000,
        });
      }
      const availableBalance = res.data.Data.data.remaining_balance;
      commit('setIsScanningCodeForBrowser', true);
      commit('setMobileQRParameters', { scanCode: scanCode, time: time, publicKey: publicKey, companyId: companyId });
      commit('setMacAddress', res.data.Data.data.mac_address);
      if (availableBalance) {
        commit('player/setLoginType', ExternalWagerLoginTypes.MobileScanCode, { root: true });
      }
      commit('depositTicketStore/setBalanceResponse', { ...availableBalance, scan_type: 'W' }, { root: true });
      commit('setIsBalanceLoading', false);
    } else {
      const macAddress = getDeviceMacAddress();
      commit('setMacAddress', macAddress);
      res = await _api.post('/clerk/getterminalinfobymacaddress', {
        mac_address: state.macAddress,
        ip: userIpInfo.ip,
        timezone: userIpInfo.timezone,
        city: userIpInfo.city,
        country_code: (userIpInfo && userIpInfo.country_code && userIpInfo.country_code.toLowerCase()) || 'null',
        client_type: isElectron ? 'ELECTRON' : 'WEB',
      });
    }

    const useTerminalData = terminalInfo => {
      if (isElectron) {
        Vue.prototype.$taxHelper.setTerminalTaxInfo(terminalInfo.tax_details);
      }

      commit('setTerminalInfo', terminalInfo);
      commit('setBrandInfo', terminalInfo.brand_settings);
      dispatch('player/getPlayerData', null, { root: true });
      dispatch('betSlip/getBetTabs', null, { root: true });
      dispatch('betSlip/getNewBetOptions', { checkLineAvailability: true }, { root: true });

      if (terminalInfo.can_user_login === '0' && terminalInfo.can_clerk_login === '1') {
        commit('authStore/setIsClerk', true, { root: true });
      }

      // player already set locale before, so use it
      if (terminalInfo.can_user_login === '0' && terminalInfo.can_clerk_login === '1') {
        commit('authStore/setIsClerk', true, { root: true });
      }

      dispatch('getClerkBalance');

      //Clerk Set Deposit Method
      if (isElectron && terminalInfo.can_clerk_login !== '1' && !rootState.settings.isScanningCodeForMobile) {
        // let isDefault = 0 //terminalInfo.active_wallet ? terminalInfo.active_wallet.RetainValueWhenScanned : 1
        commit('setIsBalanceLoading', true);
        _api
          .post('/terminal/getactivebalance', {
            mac_address: rootState.settings.macAddress,
          })
          .then(r => {
            if (r.data.IsSuccess) {
              const remaining_balance = r.data.Data.data;
              commit(
                'depositTicketStore/setIsDefaultDepositFlow',
                !remaining_balance || !remaining_balance.ticket_number,
                { root: true },
              );
              if (remaining_balance && remaining_balance.ticket_number) {
                commit(
                  'player/setLoginType',
                  LoginTypes.Clerk == rootState.player.loginType
                    ? ExternalWagerLoginTypes.ClerkDepositTicket
                    : ExternalWagerLoginTypes.DepositTicket,
                  { root: true },
                );

                const available_balance = snq(() => remaining_balance.available_balance);

                if (parseFloat(available_balance) > 0) {
                  commit('depositTicketStore/setScanCode', remaining_balance.scan_code, { root: true });
                  commit(
                    'depositTicketStore/setBalanceResponse',
                    { ...remaining_balance, scan_type: 'D' },
                    { root: true },
                  );
                }
              }
            }
            commit('setIsBalanceLoading', false);
          });
      }
      /* ODD TYPE */
      const available_odd_types = JSON.parse(terminalInfo.brand_settings.location_settings.available_odd_types);
      commit('setOddTypes', available_odd_types);
      if (rootState.player.player.LyneStyle) {
        commit('setSelectedOddType', rootState.player.player.LyneStyle);
      } else {
        if (Cookies.get('odd')) {
          commit('setSelectedOddType', Cookies.get('odd'));
        } else {
          const selectedOddType = available_odd_types.find(f => f.is_default);
          commit('setSelectedOddType', selectedOddType.code);
        }
      }

      /* LANGUAGE */
      const available_languages = JSON.parse(terminalInfo.brand_settings.location_settings.available_languages);
      if (!!rootState.player.player.PlayerInfo && !!rootState.player.player.PlayerInfo.DGS.language) {
        const userLocale = available_languages.find(f => f.id == rootState.player.player.PlayerInfo.DGS.language);
        dispatch('setLocale', userLocale.short_code);
      } else {
        if (Cookies.get('locale') && typeof Cookies.get('locale') !== 'undefined') {
          dispatch('setLocale', Cookies.get('locale'));
        } else {
          const selectedLocale = available_languages.find(f => f.is_default);
          dispatch('setLocale', selectedLocale.short_code);
        }
      }

      /* TIMEZONE */
      const available_timezones = JSON.parse(terminalInfo.brand_settings.location_settings.available_timezones);
      commit('setTimeZones', available_timezones);

      // player has already tz in cookie
      if (
        !!rootState.player.player.PlayerInfo &&
        !!rootState.player.player.PlayerInfo.DGS.schedule_timezone_id &&
        rootState.player.player.PlayerInfo.DGS.schedule_timezone_id !== '0'
      ) {
        const selectedTimeZone = available_timezones.find(
          f => f.id == rootState.player.player.PlayerInfo.DGS.schedule_timezone_id,
        );
        dispatch('setTimeZone', selectedTimeZone.id);
      } else {
        const tzFromCookie = Cookies.get('tz', {
          domain: getRootDomain(location.hostname),
        });
        if (tzFromCookie) {
          // commit("setDefaultTimeZone", Cookies.get("tz"));
          try {
            const timeZone = tzFromCookie;
            dispatch('setTimeZone', timeZone);
          } catch {
            const selectedTimeZone = available_timezones.some(f => f.is_default);

            dispatch('setTimeZone', selectedTimeZone ? selectedTimeZone.id : available_timezones[0].id);
          }
        } else {
          const selectedTimeZone = available_timezones.find(f => f.is_default);

          dispatch('setTimeZone', selectedTimeZone ? selectedTimeZone.id : available_timezones[0].id);
        }
      }

      // Note:
      // Watcher for 'selectedLocale' in App gets banners and menu list after locale set because we need locale
      if (process.env.NODE_ENV === 'production') {
        localStorage.setItem('guest_url', terminalInfo.brand_settings.guest_url);
      }
      //dispatch('cmsSettings/SET_CMS_SETTNGS', terminalInfo.brand_settings.cms_site_url, { root: true });
    };

    if (res.data.IsSuccess) {
      const terminalInfo = res.data.Data.data;
      useTerminalData(terminalInfo);
    } else {
      if (
        res.data.ExceptionMessage &&
        res.data.ExceptionMessage.length &&
        res.data.ExceptionMessage[0] === 'INVALID_TERMINAL'
      ) {
        _api
          .post('/terminal/requestnewterminal', {
            mac_address: state.macAddress,
            ip_address: userIpInfo.ip,
          })
          .then(res => {
            commit('setNewTerminalRequest', res.data.Data.data.id);
          });
      }
      else if (
        res.data.ExceptionMessage &&
        res.data.ExceptionMessage.length &&
        res.data.ExceptionMessage[0] === 'ORGANIZATION_DISABLED'
      ) {
        commit('terminalInfoError', res.data.ExceptionMessage[0]);
        Vue.toasted.show('We are under periodic maintenance', {
          type: 'error',
          position: 'bottom-center',
          duration: 5000,
        });
      } else {
        if (isElectron) {
          commit('terminalInfoError', res.data.ExceptionMessage);
        } else {
          const terminalInfoCache = await _api.get(
            process.env.VUE_APP_GUEST_URL + '/api/get-terminal-info-static-cache?mac=' + state.macAddress,
          );
          useTerminalData(terminalInfoCache.data.Data.data);
        }
      }
    }

    // commit('terminalInfoError', res.data.ExceptionMessage);
    commit('requestEnded');
  },
  getBanners: ({ commit, state }) => {
    log('[SETTINGS] banners fetching for lang: ' + state.selectedLocale.code);
    _api
      .post('/banner/getbannersbylocationid', {
        location_id: state.terminalInfo.location_id,
        banner_status: true,
        lang: `${state.selectedLocale.code}`,
      })
      .then(res => {
        commit('setBanners', res.data.Data);
      })
      .finally(() => {
        commit('requestEnded');
        log('[SETTINGS] banners fetched');
      });
  },
  getCasinoBanners: ({ commit, state }) => {
    return _api
      .get(
        state.brandSettings.cms_site_url +
        '/wp-json/cms-request/v1/get-casino-sliders/' +
        state.selectedLocale.short_code,
      )
      .then(res => {
        commit('setCasinoBanners', res.data);
      })
      .catch(err => {
        commit('setCasinoBanners', []);
      });
  },
  getLoyaltyCardDetails: ({ commit, rootState, state, dispatch }, scancode) => {
    _api
      .post('/clerk/loyalty-card/get', {
        scan_code: scancode,
      })
      .then(res => {
        if (res.data.IsSuccess) {
          const currentPlayer = rootState.player;
          const loyaltyCardDetails = res.data.Data.data[0];

          if (currentPlayer.isLogged) {
            if (currentPlayer.player.PlayerAccount === loyaltyCardDetails.account.account_name) {
              Vue.toasted.show(i18n.t('Exceptions.AlreadyLoggedIn'), {
                type: 'error',
                position: 'bottom-center',
                duration: 5000,
              });
            } else {
              dispatch('player/logout', null, { root: true });
            }
          } else {
            commit('setLoyaltyCarResponse', loyaltyCardDetails);
            router.push('/login');
          }
        }
      })
      .finally(() => {
        commit('requestEnded');
      });
  },
  getLocaleMessages: ({ state, commit }) => {
    if (!isElectron) {
      return _api
        .get(state.brandSettings.guest_url + '/common/getlanguagecache', {
          timeout: 50000,
        })
        .catch(err => {
          Sentry.setExtra('err', { err });
          Sentry.captureMessage('GET_LOCALE_MESSAGES_CATCH');
          return _api.get('/common/getlanguagecache');
        });
    }
    return _api.get('/common/getlanguagecache');
  },
  setShowScanBarcodeModal: ({ commit }, val) => {
    commit('setShowScanBarcodeModal', val);
  },
  setTimeZone: ({ commit, rootState, rootGetters }, val) => {
    //For Change player state without relogin
    const available_timezones = JSON.parse(
      rootState.settings.terminalInfo.brand_settings.location_settings.available_timezones,
    );
    if (
      !!rootState.player.player.PlayerInfo &&
      !!rootState.player.player.PlayerInfo.DGS.schedule_timezone_id &&
      rootState.player.player.PlayerInfo.DGS.schedule_timezone_id !== '0'
    ) {
      const selectedTimeZone = available_timezones.find(f => f.id == val);
      rootState.player.player.PlayerInfo.DGS.schedule_timezone_id = selectedTimeZone.id;
      commit('player/setPlayer', rootState.player.player, { root: true });
    }
    // End
    const tzFromCookie = Cookies.get('tz', {
      domain: getRootDomain(location.hostname),
    });
    if (tzFromCookie) {
      let beforeTimezone = tzFromCookie;
      if (rootGetters['player/isPlayerOrClerkLoggedIn'] && beforeTimezone !== val) {
        let obj = {
          TimeZoneId: val,
          PlayerId: rootState.player.player.DgsPlayerId,
        };
        changeTimezone(obj);
      }
    }
    commit('setDefaultTimeZone', val);
  },
  setIsScanningCodeForBrowser: ({ commit }, data) => {
    commit('isScanningCodeForMobile', data);
  },
  setMacAddress: ({ commit }, data) => {
    commit('macAddress', data);
  },
  setMobileQRParameters: ({ commit }, data) => {
    commit('mobileQRParameters', data);
  },
};

export const settings = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
